import React from 'react';
import styled from 'styled-components';
import {StyledProps, mediaQueries} from '../modules/common';
import useTranslation from 'next-translate/useTranslation';

const UnstyledFonomaAddress = (props: StyledProps): JSX.Element => {
    const {t} = useTranslation();
    const {className} = props;
    return (
        <blockquote className={className}>
            1887 Whitney Mesa Dr #1237
            <br />
            Henderson, NV 89014
            <br />
            {t('common:united-states')}
        </blockquote>
    );
};

const FonomaAddress = styled(UnstyledFonomaAddress)`
    border-left: 4px solid ${(props): string => props.theme.colors.caballa};
    font-size: 16px;
    margin: 8px 0;
    padding: 0 24px;
    line-height: 24px;
    ${mediaQueries.lessThan('small')`
        font-size: ${(props): string =>
            `${props.theme.fontSizes.small}${props.theme.unitsOfMeasure.px}`}
    `};
`;

export default FonomaAddress;
